import { zmdiToMuiIconMap } from './iconMapper';

export function resolveIcon(icon) {
  // already a React component → return as-is
  if (typeof icon === 'function') return icon;

  // string (zmdi-xxx) → map to MUI icon
  if (typeof icon === 'string') {
    return zmdiToMuiIconMap[icon] || zmdiToMuiIconMap.default;
  }

  return null;
}
